/**
 * Flags Resource
 *
 * Evaluated feature flags for the authenticated identity. The backend
 * evaluates targeting server-side; clients receive booleans only
 * (flags ADR-002). Read-only by design — there is NO client-facing write
 * surface; publishing is the internal trigger route only.
 */

import type { HttpLayer } from '../http.js';
import type { EvaluatedFlags, PlatformFlagsDocument } from '../types/flags.js';

export class FlagsResource {
  constructor(private http: HttpLayer) {}

  /**
   * Evaluate every published frontend/fullstack flag for the caller
   * (identity from the session claims). An absent key is off; an
   * evaluation failure on the server surfaces as a thrown error, never a
   * silent false (flags ADR-001).
   */
  async evaluate(): Promise<EvaluatedFlags> {
    return this.http.get('/v1/flags');
  }

  /**
   * Read the published definitions document — generation, flag definitions,
   * cohorts and the publish-history ring — for the platform-admin Releases
   * viewer. Requires platform-admin
   * scope; a non-admin principal is refused by the backend.
   */
  async definitions(): Promise<PlatformFlagsDocument> {
    return this.http.get('/v1/platform/flags');
  }
}
